import { makeStyles, createStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      alignItems: 'center',
      userSelect: 'none',
      maxWidth: 'fit-content',
    },
    dot: {
      width: 20,
      height: 20,
      borderRadius: '50%',
      border: `1px solid ${theme.palette.grey[300]}`,
      userSelect: 'none',
    },
    dotsContainer: {
      '& > * + *': {
        marginLeft: theme.spacing(0.75),
        userSelect: 'none',
      },
    },
    noDataContainer: {
      display: 'flex',
      alignItems: 'center',
      userSelect: 'none',

      '& > * + *': {
        marginLeft: theme.spacing(0.75),
        userSelect: 'none',
      },
    },
    noDataIcon: {
      cursor: 'pointer',
      userSelect: 'none',
    },
  }),
);
